const SET_GALLERY_CONTENT = 'SET_GALLERY_CONTENT';
const SET_GALLERY_BANNER_CONTENT = 'SET_GALLERY_BANNER_CONTENT ';

export {
    SET_GALLERY_CONTENT, SET_GALLERY_BANNER_CONTENT
};
